






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';

@Component({ name: 'page-footer' })
export default class PageFooter extends Vue {

  @Getter('isAuthenticated', { namespace: 'auth' })
  protected isAuthenticated!: boolean;

  protected onLoginClicked(): void {
    if (this.isAuthenticated) {
      this.$router.push('/beheer/producten');
      return;
    }

    (this.$refs.loginModal as any).show();
  }

  public get year() {
    return new Date().getFullYear();
  }
}
